import { useQuery } from '@tanstack/react-query';
import { FAQPage } from 'app/copied/models/ChatModules';

const apiUrl = 'https://mnyunlpc42.execute-api.us-east-1.amazonaws.com/qa/v1/search';
const apiKey = window.OSTRO_SEARCH_API_KEY || 'customer1_key';

export interface WebSearchResults {
  results: FAQPage[];
}

export default function useFetchWebSearchResults({ query, enabled = false }: { query: string; enabled: boolean }) {
  return useQuery({
    queryKey: ['web-search-results', query],
    queryFn: async () => {
      const requestData = {
        query: query,
        size: 5,
      };

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiKey}`,
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        results: data.results.map((result: any) => ({
          title: result.title,
          external_link: result.url,
          is_web_search: true,
          description: result.description
            ? result.description
            : result.body_content
              ? result.body_content.substring(0, 100) + '...'
              : 'No content',
        })),
      } as WebSearchResults;
    },
    enabled,
  });
}
